import React from 'react';
import type { FieldChange } from '../../hooks/useFieldChangeTracker.js';

interface FieldChangeIndicatorProps {
  fieldPath: string;
  changes?: Map<string, FieldChange>;
}

function formatValue(value: unknown): string {
  if (value === null || value === undefined) return '(empty)';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

export const FieldChangeIndicator: React.FC<FieldChangeIndicatorProps> = ({ fieldPath, changes }) => {
  if (!changes) return null;
  const change = changes.get(fieldPath);
  if (!change) return null;

  const isNew = change.previous === null;
  const isRemoved = change.current === null;

  const tooltipText = isNew
    ? 'New'
    : isRemoved
      ? `Removed (was: ${formatValue(change.previous)})`
      : `Changed from: ${formatValue(change.previous)}`;

  return (
    <span className="group/change absolute -top-1 -right-1 z-10">
      <span className="block w-1.5 h-1.5 rounded-full bg-accent" />
      <span className="absolute bottom-full right-0 mb-1 hidden group-hover/change:block whitespace-nowrap px-2 py-1 text-xs rounded-sm bg-surface border border-strong text-body shadow-lg max-w-[240px] truncate">
        {tooltipText}
      </span>
    </span>
  );
};
